export default __webpack_public_path__ + "static/media/blog-post.1.09e7833f.md";